var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { environment } from 'environments/environment';
import { UnleashClient } from 'unleash-proxy-client';
import { AppGlobals } from './app.global';
export var ToggleName;
(function (ToggleName) {
    ToggleName["ENABLE_ELIGIBILITY_MESSAGES_REDIRECT"] = "enable-eligibility-messages-redirect";
    ToggleName["ENABLE_EXAM_DELIVERIES_REDIRECT"] = "enable-exam-deliveries-redirect";
    ToggleName["ENABLE_MANAGE_GLOBAL_ADMINISTRATORS_REDIRECT"] = "enable-manage-global-administrators-redirect";
    ToggleName["ENABLE_MANAGE_REGIONAL_ADMINISTRATORS_REDIRECT"] = "enable-manage-regional-administrators-redirect";
    ToggleName["ENABLE_MANAGE_SITE_ADMINISTRATORS_REDIRECT"] = "enable-manage-site-administrators-redirect";
    ToggleName["ENABLE_GOVERNMENT_IDENTIFICATION_APPROVAL_REDIRECT"] = "enable-government-identification-approval-redirect";
    ToggleName["ENABLE_MANAGE_COUNTRIES_REDIRECT"] = "enable-manage-countries-redirect";
    ToggleName["ENABLE_MANAGE_CHAT_IDLE_TIME_REDIRECT"] = "enable-manage-chat-idle-time-redirect";
    ToggleName["ENABLE_MANAGE_PROCTOR_ALERT_REDIRECT"] = "enable-manage-proctor-alert-redirect";
    ToggleName["ENABLE_UNIVERSAL_HOURS_OF_OPERATION_REDIRECT"] = "enable-universal-hours-of-operation-redirect";
    ToggleName["ENABLE_RETENTION_POLICIES_REDIRECT"] = "enable-retention-policies-redirect";
    ToggleName["ENABLE_CONCURRENT_EXAMS_REDIRECT"] = "enable-concurrent-exams-redirect";
    ToggleName["ENABLE_PUBLIC_LOCATIONS_REDIRECT"] = "enable-public-locations-redirect";
    ToggleName["ENABLE_EXAM_OBJECTIVES"] = "enable-exam-objectives";
})(ToggleName || (ToggleName = {}));
var FeatureFlagService = (function (_super) {
    __extends(FeatureFlagService, _super);
    function FeatureFlagService(_appGlobals) {
        var _this = _super.call(this, {
            url: window.location.origin + "/individualexamscheduler/unleash/proxy",
            appName: "individualexamscheduler-ui",
            clientKey: environment.unleash.clientKey,
        }) || this;
        _this._appGlobals = _appGlobals;
        _this._appGlobals.userInfo.subscribe(function (_a) {
            var email = _a.email;
            _this.updateContext({
                userId: email,
            });
        });
        return _this;
    }
    FeatureFlagService.prototype.isEnabled = function (toggleName) {
        return _super.prototype.isEnabled.call(this, toggleName.valueOf());
    };
    return FeatureFlagService;
}(UnleashClient));
export { FeatureFlagService };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/feature-flag.service.ts.pre-build-optimizer.js